// AUTO-GENERATED GraphQL Builder for VendorPayoutAccount
import * as Builders from '../';
export class VendorPayoutAccountBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  vendorId(){ return this.add('vendorId'); }
  linkedAccountRef(){ return this.add('linkedAccountRef'); }
  status(){ return this.add('status'); }
  kycStatus(){ return this.add('kycStatus'); }
  bankSnapshotJson(){ return this.add('bankSnapshotJson'); }
  activatedDate(){ return this.add('activatedDate'); }
  accountEmail(){ return this.add('accountEmail'); }
  stakeholderRef(){ return this.add('stakeholderRef'); }
  productRef(){ return this.add('productRef'); }
  setupStep(){ return this.add('setupStep'); }
  requirementsJson(){ return this.add('requirementsJson'); }
  failureReason(){ return this.add('failureReason'); }
  requestJson(){ return this.add('requestJson'); }
  lastSyncedDate(){ return this.add('lastSyncedDate'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  paymentTransferList(b?:(q:Builders.PaymentTransferBuilder)=>void){
    if(this.depth>=5||this.v.has('paymentTransferList'))return this;
    this.v.add('paymentTransferList');
    const n=new Builders.PaymentTransferBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentTransferList { ${inner} }`);
    return this;
  }

  reversePaymentTransfer(b?:(q:Builders.PaymentTransferBuilder)=>void){
    const n=new Builders.PaymentTransferBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentTransferList { ${inner} }`);
    return this;
  }
}
